// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promo-job-prices {
	display: flex;
	align-items: flex-end;
	flex-wrap: wrap;
	gap: 12px;
}

.promo-price-row .ant-form-item {
	width: auto;
	margin-bottom: 0;
}

.promo-job-save {
	padding-bottom: 8px;
	white-space: nowrap;
}

.promo-row-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 10px 14px;
	width: 88px;
}

.promo-jobs-more {
	display: inline-block;
	margin-top: 2px;
	color: rgb(4, 42, 87);
	font-weight: 600;
	cursor: default;
}

.promo-single-field {
	max-width: 180px;
}

.promo-option-label {
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.promo-view-list {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.promo-view-job .custom-url-field-label {
	display: block;
	margin-bottom: 6px;
}

.promo-mockup {
	width: 100%;
}

.promo-mockup.promo_banner {
	margin: 0;
	border-radius: 12px;
	overflow: hidden;
	border: 1px solid var(--promo-tint);
	font-family: "Poppins", sans-serif;
}

.promo-mockup .promo_banner_top {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 6px 12px;
	background: var(--promo-color);
	color: #fff;
}

.promo-mockup .promo_banner_label {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
}

.promo-mockup .promo_banner_label svg {
	width: 14px;
	height: 14px;
	fill: currentColor;
}

.promo-mockup .promo_banner_save {
	flex-shrink: 0;
	font-size: 13px;
	font-weight: 600;
	background: rgba(255, 255, 255, 0.2);
	border-radius: 999px;
	padding: 3px 10px;
}

.promo-mockup .promo_banner_body {
	padding: 8px 12px 10px;
	background: var(--promo-wash);
}

.promo-mockup .promo_banner_title {
	font-size: 17px;
	font-weight: 600;
	color: #1f2327;
}

.promo-mockup .promo_banner_prices {
	display: flex;
	align-items: baseline;
	gap: 10px;
	margin-top: 6px;
}

.promo-mockup .promo_banner_regular {
	font-size: 15px;
	color: #666;
	text-decoration: line-through;
}

.promo-mockup .promo_banner_price {
	font-size: 20px;
	font-weight: 700;
	line-height: 1.1;
	color: var(--promo-color);
}

.promo-mockup .promo_banner_until {
	margin-top: 8px;
	font-size: 12px;
	color: #4d4f59;
}
`, "",{"version":3,"sources":["webpack://./src/components/Campaigns/Promotions.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,qBAAqB;CACrB,eAAe;CACf,SAAS;AACV;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,gBAAgB;CAChB,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,iBAAiB;CACjB,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,oCAAoC;CACpC,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,qBAAqB;CACrB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,eAAe;CACf,cAAc;AACf","sourcesContent":[".promo-job-prices {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tflex-wrap: wrap;\n\tgap: 12px;\n}\n\n.promo-price-row .ant-form-item {\n\twidth: auto;\n\tmargin-bottom: 0;\n}\n\n.promo-job-save {\n\tpadding-bottom: 8px;\n\twhite-space: nowrap;\n}\n\n.promo-row-actions {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 10px 14px;\n\twidth: 88px;\n}\n\n.promo-jobs-more {\n\tdisplay: inline-block;\n\tmargin-top: 2px;\n\tcolor: rgb(4, 42, 87);\n\tfont-weight: 600;\n\tcursor: default;\n}\n\n.promo-single-field {\n\tmax-width: 180px;\n}\n\n.promo-option-label {\n\tdisplay: block;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.promo-view-list {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.promo-view-job .custom-url-field-label {\n\tdisplay: block;\n\tmargin-bottom: 6px;\n}\n\n.promo-mockup {\n\twidth: 100%;\n}\n\n.promo-mockup.promo_banner {\n\tmargin: 0;\n\tborder-radius: 12px;\n\toverflow: hidden;\n\tborder: 1px solid var(--promo-tint);\n\tfont-family: \"Poppins\", sans-serif;\n}\n\n.promo-mockup .promo_banner_top {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n\tpadding: 6px 12px;\n\tbackground: var(--promo-color);\n\tcolor: #fff;\n}\n\n.promo-mockup .promo_banner_label {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tletter-spacing: 0.08em;\n\ttext-transform: uppercase;\n}\n\n.promo-mockup .promo_banner_label svg {\n\twidth: 14px;\n\theight: 14px;\n\tfill: currentColor;\n}\n\n.promo-mockup .promo_banner_save {\n\tflex-shrink: 0;\n\tfont-size: 13px;\n\tfont-weight: 600;\n\tbackground: rgba(255, 255, 255, 0.2);\n\tborder-radius: 999px;\n\tpadding: 3px 10px;\n}\n\n.promo-mockup .promo_banner_body {\n\tpadding: 8px 12px 10px;\n\tbackground: var(--promo-wash);\n}\n\n.promo-mockup .promo_banner_title {\n\tfont-size: 17px;\n\tfont-weight: 600;\n\tcolor: #1f2327;\n}\n\n.promo-mockup .promo_banner_prices {\n\tdisplay: flex;\n\talign-items: baseline;\n\tgap: 10px;\n\tmargin-top: 6px;\n}\n\n.promo-mockup .promo_banner_regular {\n\tfont-size: 15px;\n\tcolor: #666;\n\ttext-decoration: line-through;\n}\n\n.promo-mockup .promo_banner_price {\n\tfont-size: 20px;\n\tfont-weight: 700;\n\tline-height: 1.1;\n\tcolor: var(--promo-color);\n}\n\n.promo-mockup .promo_banner_until {\n\tmargin-top: 8px;\n\tfont-size: 12px;\n\tcolor: #4d4f59;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
